import { render, staticRenderFns } from "./FetchFriend.vue?vue&type=template&id=39756202&scoped=true"
import script from "./FetchFriend.vue?vue&type=script&lang=ts"
export * from "./FetchFriend.vue?vue&type=script&lang=ts"
import style0 from "./FetchFriend.vue?vue&type=style&index=0&id=39756202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39756202",
  null
  
)

export default component.exports